// extracted by mini-css-extract-plugin
export var text = "_81-0";